import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import AuthService from "../../services/AuthService";
import Spinner from "../spin/Spin";

const OrgHomeRedirect = () => {
  const [homeRoute, setHomeRoute] = useState(null);

  useEffect(() => {
    AuthService.resolvePostLogin().then((next) => {
      setHomeRoute(next.route);
    });
  }, []);

  if (!homeRoute) return <Spinner />;

  return <Navigate to={homeRoute} replace />;
};

export default OrgHomeRedirect;
